'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc class
 * @name HomeController
 *
 * @description
 * controller home component; using one-way data flow;
 */

var HomeController = function () {
    function HomeController($mdDialog, DataService) {
        'ngInject';

        (0, _classCallCheck3.default)(this, HomeController);
        this.$mdDialog = $mdDialog;
        this.DataService = DataService;
        this.rotateAngle = 0;
    }

    (0, _createClass3.default)(HomeController, [{
        key: 'addNew',
        value: function addNew() {
            this.topDice = void 0;
            this.botDice = void 0;
            this.adding = true;
        }
    }, {
        key: 'diceSelected',
        value: function diceSelected(dice) {
            this.selectedDice = dice;
        }
    }, {
        key: 'onSelectListDice',
        value: function onSelectListDice(ev) {
            console.log('select ev:', ev);
        }
    }, {
        key: 'onSelectListDice',
        value: function onSelectListDice(index) {
            if (this.selectedDice === void 0) return;
            this.selectedDice === 'top' ? this.topDice = index : this.botDice = index;
            this.selectedDice = void 0;
        }
    }, {
        key: 'rotate',
        value: function rotate(ang) {
            this.rotateAngle += ang;
            console.log(this.rotateAngle);
        }
    }]);
    return HomeController;
}();

exports.default = HomeController;


// WEBPACK FOOTER //
// ./client/app/components/home/home.controller.js